/**
 * "In <place> · show on the atlas" beside a quest NPC in the journal (Tome UI Round 3, the next
 * program's E2). It opens the World Atlas on the NPC's map; an NPC on no map the atlas shows (a draft,
 * a pocket map) says so instead of offering a link that would go nowhere.
 */
import React from 'react';
import { npcAtlasPlace, useShowOnAtlas } from '../WorldMap/atlasFocus';

export const JournalAtlasLink: React.FC<{ npcId: string | null | undefined; role: string }> = ({ npcId, role }) => {
  const showOnAtlas = useShowOnAtlas();
  if (!npcId) return null;
  const place = npcAtlasPlace(npcId);
  if (!place) return <>{' '}<small className="quest-journal-place quest-journal-place--off-atlas">not on the atlas yet</small></>;
  return <>{' '}<span className="quest-journal-place">
    in {place.name}{' · '}
    <button type="button" className="quest-journal-place-link" data-testid={`quest-journal-atlas-${role}`}
      aria-label={`Show ${place.name} on the World Atlas`} onClick={() => showOnAtlas(place.mapId)}>show on the atlas</button>
  </span></>;
};
